export default "__VITE_ASSET__ecB4Yx4C__"